import { ValidationErrors } from '@angular/forms';

export type CharacterSpec = string[] | RegExp;

export interface AllowCharacterValidationResult {
  blockedAllowed: boolean;
  blockedDisallowed: boolean;
}

export const mapToValidationError = (validation: AllowCharacterValidationResult): ValidationErrors => {
  return  {
    ...(validation.blockedAllowed && {allowedcharacters: true} || {}),
    ...(validation.blockedDisallowed && {disallowedcharacters : true} || {})
  };
};

export const removeValidationError = (validation: ValidationErrors): ValidationErrors => {
  delete validation.allowedcharacters;
  delete validation.disallowedcharacters;
  return validation;
};

export const validateAllowedCharacters =
  (char: string, allowedChars: CharacterSpec | undefined, disallowedChars: CharacterSpec | undefined)
    : AllowCharacterValidationResult | undefined => {
  const blockedAllowed = !testCharSpecWithFallback(char, allowedChars, true);
  const blockedDisallowed = testCharSpecWithFallback(char, disallowedChars, false);
  if (blockedAllowed || blockedDisallowed) {
    return {
      blockedAllowed,
      blockedDisallowed
    };
  }
  return undefined;
};

export const testCharSpecWithFallback = (char: string, charSpec: CharacterSpec | undefined,
                                         isAllowed: boolean): boolean => {
  if (!charSpec) {
    return isAllowed;
  }
  const isAllowCharSpecSet = isCharSpecSet(charSpec);
  if (isAllowCharSpecSet && charSpec) {
    return  testCharSpec(char, charSpec);
  }
  return isAllowed;
};

/***
 * testCharSpec returns true whether the given char matches CharacterSpec RegEx or is one of
 * charSpec array else false.
 * @param char the character to compare
 * @param charSpec the character spec as RegEx or string[] against which char is compared
 *
 * @return true if comparison passes, false else
 * ***/
export const testCharSpec = (char: string, charSpec: CharacterSpec): boolean => {
  if (isRegEx(charSpec)) {
    return charSpec.test(char);
  } else {
    return charSpec.includes(char);
  }
};

const isCharSpecSet = (charSpec?: CharacterSpec): boolean => {
  if (!charSpec) {
    return false;
  }
  return !(!isRegEx(charSpec) && charSpec.length === 0);
};


const isRegEx = (pattern: CharacterSpec): pattern is RegExp => {
  return pattern instanceof RegExp;
};


